module.exports = __webpack_public_path__ + "static/media/close.bbabba58.svg";